import { graphql } from "api/cms-website/generated";

export const QuestionsFragment = graphql(/* GraphQL */ `
    fragment QuestionsFragment on ComponentComponentsQuestions {
        id
        noMarginBottom
        questionsTitle: title
        items {
            ...QuestionItemFragment
        }
    }
`);
